function getCorrectPaywall(): Element | null {
  return (
    document.querySelector("ws-paywall:not(dialog ws-paywall)") ??
    document.querySelector("ws-paywall")
  );
}

function getOfferName(): string {
  const paywall = getCorrectPaywall();

  if (!(paywall instanceof HTMLElement)) {
    throw new Error("Paywall element not found or is not an HTMLElement.");
  }

  const selector = ".paid-barrier__headline";
  const headline =
    paywall.shadowRoot?.querySelector(selector) ??
    (paywall.querySelector(selector) as HTMLElement | null);

  if (!headline?.textContent) {
    throw new Error("Headline content of paywall not found or is empty.");
  }

  return headline.textContent.replace(/\s+/g, " ").trim();
}

function getOfferId(): string {
  const paywall = getCorrectPaywall();

  if (!paywall) {
    throw new Error("Paywall element is null or undefined.");
  }

  try {
    const selector = ".paid-barrier__button--zephr";
    const urlOffer =
      paywall.shadowRoot?.querySelector(selector) ??
      (paywall.querySelector(selector) as HTMLElement);

    const href = urlOffer.getAttribute("href");

    const afterCheckout = href?.split("checkout/")[1]?.split(/\/|\?/)[0];
    return afterCheckout || "default";
  } catch {
    throw new Error("Unable to find the offer URL.");
  }
}

function getOriginalReferrer(): string | undefined {
  const referrer = document.referrer;
  const currentHost = window.location.hostname;

  if (referrer && !referrer.includes(currentHost) && referrer !== "") {
    sessionStorage.setItem("originalReferrer", JSON.stringify(referrer));
    return referrer;
  } else {
    const savedReferrer = sessionStorage.getItem("originalReferrer");
    return savedReferrer ? JSON.parse(savedReferrer) : undefined;
  }
}

async function getUserId(): Promise<string | undefined> {
  const user = document.querySelector("ws-user");
  if (user) {
    await window.customElements.whenDefined("ws-user");
    return (await user.getStatus()).hashedUserId ?? undefined;
  }
  return undefined;
}

export function getHost(): string {
  return window.location.hostname;
}

const subxUtils = {
  getCorrectPaywall,
  getOfferId,
  getOfferName,
  getOriginalReferrer,
  getUserId,
};

export { subxUtils };
